module.exports = __webpack_public_path__ + "JZ-9df9e194.png";